export default __webpack_public_path__ + "static/media/David.f3d944ed.jpg";